


























/** @format */
import CountCardSimpleGrid from '@/components/count-card/simple-grid.vue';
import CountCard from '@/components/count-card/index.vue';
import EchartOption, { ColorList } from '@/common/const/e-chart-options';

import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
@Component({
  components: {
    CountCardSimpleGrid,
    CountCard
  }
})
export default class SpaceCard extends Vue {
  @Prop() private total: any;
  barOptions: EchartOption = new EchartOption();

  get countCardsData() {
    const {
      parkCount = '--',
      spaceCount = 0,
      unfixedSpaceCount = 0,
      propertyRightCount = '--',
      soldCount = 0,
      unsoldCount = 0,
      longRentCount = '--',
      rentAlreadyCount = 0,
      noRentCount = 0,
      temporaryStopCount = '--'
    } = this.total || {};
    return [
      {
        title: '车场数量(个)',
        count: parkCount,
        echart: {
          type: 'bar',
          total: spaceCount,
          seriesData:
            Object.keys(this.total).length > 0
              ? [
                  {
                    name: '总车位',
                    value: spaceCount,
                    color: ColorList[0]
                  },
                  {
                    name: '非固定车位',
                    value: unfixedSpaceCount,
                    color: ColorList[1]
                  }
                ]
              : []
        }
      },
      {
        title: '产权用途(个)',
        count: '',
        echart: {
          type: 'pie',
          total: propertyRightCount,
          seriesData:
            Object.keys(this.total).length > 0
              ? [
                  {
                    name: '已售',
                    value: soldCount
                  },
                  {
                    name: '未售',
                    value: unsoldCount
                  }
                ]
              : []
        }
      },
      {
        title: '长租用途(个)',
        count: '',
        echart: {
          type: 'pie',
          total: longRentCount,
          seriesData:
            Object.keys(this.total).length > 0
              ? [
                  {
                    name: '已租',
                    value: rentAlreadyCount
                  },
                  {
                    name: '未租',
                    value: noRentCount
                  }
                ]
              : []
        }
      },
      {
        title: '临停用途(个)',
        count: '',
        echart: {
          type: 'pie',
          total: temporaryStopCount,
          seriesData:
            Object.keys(this.total).length > 0
              ? [
                  {
                    name: '临停',
                    value: temporaryStopCount
                  }
                ]
              : []
        }
      }
    ];
  }
}
